import { Controller } from 'stimulus';
import universalTracking from '../tracking/universalTracking';

class FilterSelect extends Controller {
  connect() {
    this.isExpanded = this.toggleTarget.getAttribute('aria-expanded') === 'true';

    this.setLabel();
  }

  onToggleClick() {
    this.isExpanded = !this.isExpanded;
    this.toggleA11Y();
  }

  onFilterChange() {
    const labelText = this.setLabel();
    this.fireChangeEvent();

    universalTracking.event(`Filter ${this.element.id}`, 'change', labelText);
  }

  value() {
    const activeRadio = this.element.querySelector('input[type="radio"]:checked');
    const activeCheckboxes = Array.prototype.slice.call(
      this.element.querySelectorAll('input[type="checkbox"]:checked'),
    );

    return { activeRadio, activeCheckboxes };
  }

  setLabel() {
    const { activeCheckboxes } = this.value();
    let labelText = '';

    const appendix = activeCheckboxes.length;
    this.setAppendix(appendix);

    labelText = this.data.get('default-label');
    this.setLabelText(`${labelText}`);

    return labelText;
  }

  setAppendix(length) {
    this.appendixTarget.textContent = length;

    if (length === 0) {
      this.appendixTarget.style.display = 'none';
    } else {
      this.appendixTarget.style.display = 'inline';
    }
  }

  setLabelText(text) {
    this.toggleLabelTarget.textContent = text;
  }

  setMultiSelected(hasMultipleSelected) {
    this.toggleTarget.classList[hasMultipleSelected ? 'add' : 'remove']('has-multi-selected');
  }

  onWindowKeyUp(event) {
    if (!this.isExpanded) {
      return;
    }

    if (event.key === 'Escape') {
      this.isExpanded = false;
      this.toggleA11Y();
    }
  }

  onWindowClick(event) {
    if (!this.isExpanded) {
      return;
    }

    // If click outside of the dropdown...
    if (!event.target.closest(`#${this.element.id}`)) {
      this.isExpanded = false;
      this.toggleA11Y();
    }
  }

  toggleA11Y() {
    this.dropdownTarget.setAttribute('aria-hidden', this.isExpanded ? 'false' : 'true');
    this.toggleTarget.setAttribute('aria-expanded', this.isExpanded ? 'true' : 'false');

    // If the dropdown is being hidden and the user is focussed on an (form) element
    // inside the dropdown. We move the focus back to the toggle button.
    if (!this.isExpanded && this.dropdownTarget.contains(document.activeElement)) {
      this.toggleTarget.focus();
    }
  }

  fireChangeEvent() {
    const event = new CustomEvent('update', {
      detail: this.value(),
    });
    this.element.dispatchEvent(event);
  }
}

FilterSelect.targets = [
  'dropdown',
  'toggle',
  'toggleLabel',
  'appendix',
];

export default FilterSelect;
